import { map, pick } from 'lodash'

const menuCurationTaskDetailLevelAndLanguageFormInitialValues = values => ({
  languageIds: map(values?.languages, ({ language }) => language.id),
  ...pick(values, ['curationDetailLevel']),
})

export default menuCurationTaskDetailLevelAndLanguageFormInitialValues
